export const ApiPaths = {
  signUp: '/sign-up',
  auth: '/auth',
  signIn: '/oauth/token',
  gpt: '/gpt',
  curriculums: '/curriculums',
  stripe: '/stripe',
  courses: '/courses',
  zoomMeetings: '/zoom-meetings',
  fcmToken: '/fcm-token',
  reportIssue: '/report-issue',
  schedule: '/schedules',
  userAvailability: '/user-availability',
  sections: '/sections',
  user: '/user',
  courseStudents: `/course-students`,
  courseTutors: '/course-tutors',
  subjects: '/subjects',
  lessonHistory: '/lesson-history',
  meetingRequests: '/meeting-requests',
  lessonStudentFeedbacks: '/lesson-student-feedbacks',
  lessonTutorFeedbacks: '/lesson-tutor-feedbacks',
  billing: '/billing',
  trials: '/trials',
  resourceFeedback: '/resource-feedback',
  homeworks: '/homeworks',
  paymentHistory: '/payment-history',
  invoices: '/invoices',
  oneToOneTutorRates: '/one-to-one-tutor-rates',
  groupTutorRates: '/group-tutor-rates',
  flexiblePlans: '/flexible-plans',
  subscriptionPlans: '/subscription-plans',
  premium: '/premium',
  tutors: '/tutors',
  penaltyWaivers: '/penalty-waivers',
  progress: '/progress',
  submissions: '/submissions',
  transactionLogs: '/transaction-logs',
  teamMeetings: '/team-meetings',
  tenants: '/tenants',
  metaTags: '/meta-tags',
  onboarding: '/onboarding',
  call: '/call',
  resources: '/resources',
  waitingRoom: '/waiting-room',
  questions: '/questions',
  quizzes: '/quizzes',
  topics: '/topics',
  subTopics: '/subtopics',
  structuredEssayQuestions: '/structuredEssayQuestions',
  sessions: '/sessions',
  tags: '/tags',
  bookmarks: '/bookmarks',
  diagnostics: '/diagnostics',
  usages: '/usages',
  platform: '/platform',
  analytics: '/analytics',
  customQuiz: '/custom-quiz',
  customSubmission: '/custom-submissions',
  settings: '/settings',
  tutorRatings: '/tutor-ratings',
  paymentHesitationFeedback: '/payment-hesitation-feedback',
};

export const AdminApiPaths = {
  courses: '/admin/courses',
  courseTutors: '/admin/course-tutors',
  courseStudents: '/admin/course-students',
  sections: '/admin/sections',
  users: '/admin/users',
  external: '/admin/external',
  courseTemplates: '/admin/course-templates',
  zoomMeetings: '/admin/zoom-meetings',
  teamMeetings: '/admin/team-meetings',
  resources: '/admin/resources',
  userAvailability: '/admin/user-availability',
  schedule: '/admin/schedules',
  meetingRequests: '/admin/meeting-requests',
  lessonHistory: '/admin/lesson-history',
  lessonStudentFeedbacks: '/admin/lesson-student-feedbacks',
  lessonTutorFeedbacks: '/admin/lesson-tutor-feedbacks',
  trials: '/admin/trials',
  homeworks: '/admin/homeworks',
  adminFlexiblePlans: '/admin/flexible-plans',
  adminSubscriptionPlans: '/admin/subscription-plans',
  adminGroups: '/admin/groups',
  adminCoursePermissionTemplates: '/admin/course-permission-templates',
  adminStudentFlexibleRateVersions: '/admin/student-flexible-rate-versions',
  adminStudentFlexibleRates: '/admin/student-flexible-rates',
  adminStudentSubscriptionRateVersions:
    '/admin/student-subscription-rate-versions',
  adminStudentSubscriptionRates: '/admin/student-subscription-rates',
  adminCoursePricingTemplates: '/admin/course-pricing-templates',
  adminRoles: '/admin/roles',
  adminSettings: '/admin/settings',
  paymentHistory: '/admin/payment-history',
  transactionLogs: '/admin/transaction-logs',
  invoices: '/admin/invoices',
  oneToOneTutorRateVersions: '/admin/one-to-one-tutor-rate-versions',
  oneToOneTutorRateStudentTypes: '/admin/one-to-one-tutor-rate-student-types',
  oneToOneTutorRates: '/admin/one-to-one-tutor-rates',
  groupTutorRateVersions: '/admin/group-tutor-rate-versions',
  groupTutorRateCourseTypes: '/admin/group-tutor-rate-course-types',
  groupTutorRates: '/admin/group-tutor-rates',
  penaltyWaivers: '/admin/penalty-waivers',
  metaTags: '/admin/meta-tags',
  redirections: '/admin/redirections',
  sitemap: '/admin/sitemap',
  manualAdjustments: '/admin/manual-adjustments',
  tutorSorting: '/admin/tutor-sorting',
  callLogs: '/admin/call-logs',
  tutorRoles: '/admin/tutor-roles',
  waitingRoom: '/admin/waiting-room',
  questions: '/admin/questions',
  quizzes: '/admin/quizzes',
  topics: '/admin/topics',
  subTopics: '/admin/subtopics',
  students: '/admin/students',
  submissions: '/admin/submissions',
  gpt: '/admin/gpt',
  structuredEssayQuestions: '/admin/structuredEssayQuestions',
  notificationLogs: '/admin/notification-logs',
  crm: '/admin/crm',
  courseCreditTransferLogs: '/admin/course-credit-transfer-logs',
  adminTutorRatings: '/admin/tutor-ratings',
};
